<template>
  <component
    :is="tag"
    v-on="$listeners"
    class="chat-contact-item"
    :class="{ 'chat-contact-item--incoming': shouldHighlightIncoming(user) }"
  >
    <B-Avatar
      size="42"
      :badge="user.unread_count.toString()"
      :src="user.student_uuid ? 'https://rb.cloudedu.pro/studentPhoto/' + user.student_uuid + '.jpg' : user.avatar"
      v-if="user.unread_count > 0"
      variant="light-secondary"
      badge-variant="danger"
    />
    <B-Avatar
      size="42"
      v-if="user.unread_count == 0"
      :src="user.student_uuid ? 'https://rb.cloudedu.pro/studentPhoto/' + user.student_uuid + '.jpg' : user.avatar"
      variant="light-secondary"
    />
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0">
        <b-badge v-if="user.member && user.member.code" variant="light-success">{{ user.center_code }} {{ user.member.code }}</b-badge>
        <b-badge v-if="user.member.code === null && user.lead_center_id === null" variant="light-danger">未有分校</b-badge>
        <b-badge v-if="user.lead_center_id" variant="light-warning">{{ user.center_code }}</b-badge>
        {{ user.member && user.member.zh_name ? user.member.zh_name : user.display_name }}
        <font-awesome-icon
        v-if="user.is_pinned === true"
        icon="fa-solid fa-thumbtack"
        class="fa-fade text-danger"
        />
      </h5>
      <div v-if="user.message_type == 'text'">
        <p
          class="card-text text-truncate"
          style="font-size:12px;color:#999;"
          v-html="formatPreviewMessage(user.message)"
        ></p>
      </div>

      <div v-else-if="user.message_type == 'image'">
        <feather-icon
            icon="CameraIcon"
            size="14"
        />
      </div>

      <div v-else-if="user.message_type == 'sticker'">
        <p class="card-text text-truncate">
          sticker
        </p>
      </div>

      <div v-else-if="user.message_type == 'audio'">
        <feather-icon
            icon="Volume2Icon"
            size="14"
        />
      </div>

      <div v-else-if="user.message_type == 'video'">
        <feather-icon
            icon="VideoIcon"
            size="14"
        />
      </div>

      <div v-else-if="user.message_type == 'document'">
        <feather-icon
            icon="PaperclipIcon"
            size="14"
        />
      </div>

      <div v-else>
        <p class="card-text text-truncate">
          other message type
        </p>
      </div>

      
    </div>
    <div
      v-if="isChatContact"
      class="chat-meta text-nowrap"
    >
      <small class="float-right mb-25 chat-time">{{ formatDate(user.last_time) }}</small>
      
    </div>  
    <hr class="chat-divider" />
  </component>
</template>

<style scoped>
.chat-contact-item{
  border-bottom: 1px solid #e5e5e5;
}

.chat-contact-item--incoming {
  background-color: #ffe6e6;
}

.chat-divider {
  margin: 0.4rem 0 0;
  border: none;
  border-top: 1px solid #eee;
}
</style>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'
//import { formatDateToMonthShort } from '@core/utils/filter'
import useChat from './useChat'

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    user: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      dedfault: false,
    },
  },
  setup() {
    const { resolveAvatarBadgeVariant } = useChat()
    function normalizeNumber(value) {
      return String(value || '').replace(/\D/g, '')
    }

    function shouldHighlightIncoming(contact) {
      const fromNumber = normalizeNumber(contact && (contact.from_number || contact.from))
      if (!fromNumber) return false
      return fromNumber !== '85266205422'
    }

    function escapeHtml(text) {
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    }

    function formatPreviewMessage(text) {
      const preview = String(text || '').slice(0, 20)
      const safeText = escapeHtml(preview)
      const withDoubleBold = safeText.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
      return withDoubleBold.replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>')
    }

    function formatDate(delivery_datetime){
      const date = new Date(delivery_datetime);
      //date.setHours(date.getHours() - 8);
      const now = new Date();
      const inputMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const diffInDays = Math.floor((nowMidnight - inputMidnight) / (1000 * 60 * 60 * 24));
      if (diffInDays === 0) return date.toTimeString().slice(0, 5);
      if (diffInDays === 1) return 'Yesterday';
      if (diffInDays === 2) return '2 days ago';
      return date.toISOString().split('T')[0];
    }
    return {
      formatDate,
      resolveAvatarBadgeVariant,
      formatPreviewMessage,
      shouldHighlightIncoming,
    }
  },
}
</script>

<style>

</style>
